import { Page } from '@/components/layout/Page';
import { PageContent } from '@/components/layout/PageContent';
import { Skeleton } from '@/components/ui/Skeleton';

function RunnerCardSkeleton() {
    return (
        <div className="bg-white p-4 rounded-2xl shadow-sm ring-1 ring-slate-100 flex items-center gap-4">
            <Skeleton className="w-14 h-14 rounded-2xl shrink-0" />
            <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-36" />
                <Skeleton className="h-3 w-24" />
            </div>
            <Skeleton className="h-8 w-8 rounded-xl shrink-0" />
        </div>
    );
}

export function RaceDetailsSkeleton() {
    return (
        <Page>
            {/* Header area */}
            <div className="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-slate-100 px-4 py-4">
                <div className="max-w-5xl mx-auto flex items-center gap-3">
                    <Skeleton className="w-8 h-8 rounded-full" />
                    <div className="space-y-1.5 flex-1">
                        <Skeleton className="h-3 w-16" />
                        <Skeleton className="h-5 w-48" />
                    </div>
                </div>
            </div>

            <PageContent width="standard" className="space-y-6">
                {/* Title */}
                <div className="space-y-2">
                    <Skeleton className="h-8 w-64" />
                    <Skeleton className="h-4 w-40" />
                </div>

                {/* Description */}
                <Skeleton className="h-20 w-full rounded-3xl" />

                {/* Tab bar */}
                <div className="bg-slate-100 p-1.5 rounded-2xl flex gap-1">
                    <Skeleton className="flex-1 h-10 rounded-xl" />
                    <Skeleton className="flex-1 h-10 rounded-xl" />
                </div>

                {/* Runner list */}
                <div className="grid gap-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                        <RunnerCardSkeleton key={i} />
                    ))}
                </div>
            </PageContent>
        </Page>
    );
}
